/*
  Nucery · free gift with a 100% code
  ---------------------------------------------------------------------------
  Called by assets/nucery-cart-drawer.js after every bag redraw.
  - The bag holds at least one piece, a code is applied, and the bag total is
    €0 before shipping  ->  the gift (window.NuceryFreeGiftConfig) is added once.
    The 100% code makes it €0 too, so it stays free at checkout.
  - The bag is no longer €0 (code removed, a 70% code, ...) or holds only the
    gift  ->  the gift is removed. Its quantity is kept at 1.
  - If adding the gift makes the total go above €0 (a code that does not cover
    every piece), it is removed and not tried again for that code.
  The invite line shows until the gift is in the bag, then the "Your free gift
  is in your bag" box shows instead.
*/
(function () {
  'use strict';
  var C = window.NuceryFreeGiftConfig;
  if (!C || !C.variantId) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;
  var KEY = 'nucery_gift_skip';

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.ok ? r : Promise.reject(r); });
  }

  function getCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function codes(cart) {
    return (cart.discount_codes || []).filter(function (d) { return d.applicable !== false; })
      .map(function (d) { return String(d.code || '').toUpperCase(); }).sort().join(',');
  }

  function skipped(cart) {
    try { return sessionStorage.getItem(KEY) === codes(cart); } catch (e) { return false; }
  }

  function skip(cart) {
    try { sessionStorage.setItem(KEY, codes(cart)); } catch (e) {}
  }

  function decorate(cart, gift) {
    var invite = document.querySelector('[data-nfg-invite]');
    var ok = document.querySelector('[data-nfg-ok]');
    if (invite) invite.hidden = !!gift;
    if (ok) ok.hidden = !gift;
    if (!gift) return;
    var row = document.querySelector('.nucery-cart-drawer__item[data-line-key="' + gift.key + '"]');
    if (!row || row.classList.contains('is-free-gift')) return;
    row.classList.add('is-free-gift');
    var title = row.querySelector('.nucery-cart-drawer__item-titlewrap');
    if (title) title.insertAdjacentHTML('beforeend', '<span class="nucery-free-gift__tag">🎁 ' + (C.label || 'Free gift') + '</span>');
    var price = row.querySelector('.nucery-cart-drawer__item-price');
    if (price && gift.original_line_price > gift.final_line_price) {
      var was = new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cart.currency || 'EUR' })
        .format(gift.original_line_price / 100);
      price.insertAdjacentHTML('afterbegin', '<s class="nucery-free-gift__was">' + was + '</s>');
    }
  }

  window.NuceryFreeGift = function (cart, redraw) {
    var items = cart.items || [];
    var gift = null, pieces = 0;
    items.forEach(function (it) {
      if (String(it.variant_id) === String(C.variantId)) gift = it;
      else pieces += it.quantity;
    });
    var total = Number(cart.total_price || 0);
    var hasCode = codes(cart) !== '';
    decorate(cart, gift);
    if (busy) return;

    var change = null;
    if (gift && (pieces === 0 || total > 0)) {
      if (total > 0 && pieces > 0) skip(cart);           // this code does not cover the gift
      change = post('cart/change.js', { id: gift.key, quantity: 0 });
    } else if (gift && gift.quantity > 1) {
      change = post('cart/change.js', { id: gift.key, quantity: 1 });
    } else if (!gift && pieces > 0 && hasCode && total === 0 && !skipped(cart)) {
      change = post('cart/add.js', { items: [{ id: C.variantId, quantity: 1 }] });
    }
    if (!change) return;

    busy = true;
    change
      .then(getCart)
      .then(function (fresh) { busy = false; if (typeof redraw === 'function') redraw(fresh, { animate: false }); })
      .catch(function () { busy = false; });
  };
})();
